module.exports = function() {
    var allPanels = $('.accordion__item > dd, .jobs-contact__item > dd').hide();
    
    $('.accordion__item > dt, .jobs-contact__item > dt').click(function() {
        $this = $(this);
        $target =  $this.next();

        if(!$target.hasClass('active')){
            allPanels.removeClass('active').slideUp();
            $target.addClass('active').slideDown();
        } else {
            $target.removeClass('active').slideUp();
        }
        
        return false;
    });
};